<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageAlt: page.headingImageAlt,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :content="page.content" :subtitle="page.subtitle">
			<template #content>
				<div class="columns column6">
					<div class="title-reverse-wrapper">
						<h1>{{ page.title }}</h1>
						<h2 class="subtitle">{{ page.subtitle }}</h2>
					</div>
					<p v-if="page.bookingID">
						<book-button rel="noopener noreferrer" :packageid="page.bookingID" class="button button-cta">
							{{ $t('bookNow') }}
						</book-button>
					</p>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</template>
		</main-content>

		<section class="main-content background-light align-left">
			<div class="row carousel-row">
				<div class="columns column6">
					<div v-parse-links v-html="page.details" />
				</div>
				<div class="columns column6 package-icons">
					<div v-for="item in page.extras" :key="item.id" class="package-icon">
						<font-awesome-icon
							v-if="item.icon == 'buildingColumnsSolid'"
							:icon="`fas fa-building-solid`"
							size="1x"
						/>
						<font-awesome-icon v-else :icon="`fal fa-${item.icon}`" size="1x" />
						<span>{{ item.content }}</span>
					</div>
				</div>
			</div>
		</section>

		<section class="package-prefooter">
			<div class="row align-center">
				<div class="columns column12">
					<div v-parse-links v-html="page.bannerContent" />
					<book-button :data-packageID="page.bookingID" class="button button-cta">
						<span>{{ $t('bookNow') }}</span>
					</book-button>
				</div>
			</div>
		</section>

		<bottom-images class="package-bottom-images" :items="page.images" />

		<pre-footer v-if="page && page.footerSection.length" :footer-section="page.footerSection[0]">
			<picture>
				<source v-if="footerSection.imageWebp" :srcset="footerSection.imageWebp" type="image/webp" />
				<source :srcset="footerSection.image" />
				<img :src="footerSection.image" class="bg-image" loading="lazy" :alt="footerSection.imageAlt" />
			</picture>
		</pre-footer>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss">
.item {
	cursor: pointer;
}

.package-bottom-images {
	padding-top: 75px;
}

.package-prefooter {
	padding: 50px 0;
}

.package-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
}

.package-icon {
	width: 46%;
	background: #fff;
	padding: 45px 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	margin: 10px auto;
}

.package-icon i,
.package-icon svg {
	color: $cta-color;
	font-size: 66px;
	margin: 0 auto 40px;
}

.package-icon span {
	width: 100%;
	font-size: 18px;
}

.carousel {
	padding: 20px 20px 0;
	position: relative;
}

.carousel-row {
	overflow: hidden;

	ul,
	:deep(ul) {
		padding-left: 20px;
	}
}

@media (max-width: 920px) {
	.carousel {
		padding: 20px 0 0;
	}
}

@media (max-width: 580px) {
	.package-icon {
		width: 90%;
		max-width: 300px;
	}
}
</style>
